import React from 'react'
import { summarizeOrderFinancials } from 'src/utils/orderFinancials'

// Financial metadata only: this component never creates or receipts a product.
const OrderFinancialBreakdown = ({
  orders = [],
  context = {},
  hidden = false,
  receiving = false,
  conflict = false,
  compact = false,
}) => {
  if (hidden) return null
  const summary = summarizeOrderFinancials(orders, context)
  if (conflict || summary.hasConflict)
    return (
      <p role='alert'>
        Submitted order totals need review. Conflicting saved amounts were
        found.
      </p>
    )
  if (!summary.hasFinancialSnapshots) return null
  const breakdown = (
    <section
      aria-label='Submitted order totals'
      style={{ margin: '16px 0', breakInside: 'avoid' }}
    >
      {summary.purchaseOrders.map(po => (
        <div key={po.key} style={{ marginBottom: 12 }}>
          <strong>Submitted order · {po.purchaseOrderNumber} (ex VAT)</strong>
          <div>
            Goods: £
            {(po.orderFinancialSnapshot.goodsSubtotalPennies / 100).toFixed(2)}
          </div>
          <div>
            Delivery: £
            {(
              po.orderFinancialSnapshot.appliedDeliveryFeePennies / 100
            ).toFixed(2)}
          </div>
          <div>
            <strong>
              Order total: £
              {(po.orderFinancialSnapshot.orderTotalPennies / 100).toFixed(2)}
            </strong>
          </div>
        </div>
      ))}
      {summary.legacyLineCount > 0 && (
        <p>
          Some lines have no saved submission totals and are excluded from this
          breakdown.
        </p>
      )}
      {receiving && (
        <p>Delivery is a financial charge and does not need receiving.</p>
      )}
    </section>
  )
  return compact ? (
    <details>
      <summary>
        Submitted order totals ({summary.purchaseOrders.length} POs)
      </summary>
      {breakdown}
    </details>
  ) : (
    breakdown
  )
}
export default OrderFinancialBreakdown
